import { endOfMonth, getWeeksInMonth } from "@internationalized/date";

import { CalendarCell } from "./CalendarCell";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";
import styled from "styled-components";
import { useCalendarGrid } from "@react-aria/calendar";
import { useLocale } from "@react-aria/i18n";

const TextWrapper = styled(Text)`
    text-align: center;
`;

export function CalendarGrid({
    state, offset = {},
    disableDays = [],
    enableDaysFromDate = null,
    enableDaysUntilDate = null
}) {
    let { locale } = useLocale();
    let startDate = state.visibleRange.start.add(offset);
    let endDate = endOfMonth(startDate);
    let { gridProps, headerProps, weekDays } = useCalendarGrid(
        {
            startDate,
            endDate,
        },
        state
    );

    // Get the number of weeks in the month so we can render the proper number of rows.
    let weeksInMonth = getWeeksInMonth(startDate, locale);

    return (
        <table {...gridProps} className="flex-1">
            <thead {...headerProps}>
                <tr>
                    {weekDays.map((day, index) => (
                        <th key={`${day}-${index}`}>
                            <TextWrapper
                                a
                                variant="Descriptive_1_1"
                                color="Gray_3"
                            >
                                {day}
                            </TextWrapper>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {[...new Array(weeksInMonth).keys()].map((weekIndex) => (
                    <tr key={weekIndex}>
                        {state
                            .getDatesInWeek(weekIndex, startDate)
                            .map((date, i) =>
                                date ? (
                                    <CalendarCell
                                        key={`${date.year}-${date.month}-${date.day}`}
                                        state={state}
                                        date={date}
                                        currentMonth={startDate}
                                        disableDays={disableDays}
                                        enableDaysFromDate={enableDaysFromDate}
                                        enableDaysUntilDate={enableDaysUntilDate}
                                    />
                                ) : (
                                    <td key={`empty-${weekIndex}-${i}`} />
                                )
                            )}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

CalendarGrid.propTypes = {
    state: PropTypes.object.isRequired,
    offset: PropTypes.object,
    disableDays: PropTypes.array,
    enableDaysFromDate: PropTypes.number,
    enableDaysUntilDate: PropTypes.number,
};
